import { t } from "ttag";

import { getUserId } from "metabase/current-user";
import type {
  EntityModerationIconProps,
  ModerationStatusIconProps,
} from "metabase/plugins";
import { useSelector } from "metabase/redux";
import { Icon } from "metabase/ui";

import { getVerifiedByText, getVerifiedReview } from "../../utils";

/**
 * The verified badge next to a question's, model's, metric's or dashboard's
 * title, with who verified it and when in its tooltip. Renders nothing for
 * unverified items.
 */
export function EntityModerationIcon({
  moderationReviews,
}: EntityModerationIconProps) {
  const currentUserId = useSelector(getUserId);
  const review = getVerifiedReview(moderationReviews);

  if (!review) {
    return null;
  }

  return (
    <Icon
      name="verified_filled"
      c="core-brand"
      tooltip={getVerifiedByText(review, currentUserId)}
      data-testid="entity-verified-icon"
    />
  );
}

/**
 * The verified badge in lists: collection items, search results, pickers,
 * recents and the command palette. Renders nothing for unverified items.
 */
export function ModerationStatusIcon({
  status,
  filled = false,
  ...iconProps
}: ModerationStatusIconProps) {
  if (status !== "verified") {
    return null;
  }

  return (
    <Icon
      c="core-brand"
      tooltip={t`Verified`}
      {...iconProps}
      name={filled ? "verified_filled" : "verified"}
    />
  );
}
